<script>
import Vue from 'vue'
import { findRef } from '@/mixins/findRef'
const StatusTooltip = Vue.component('StatusTooltip', {
  mixins: [findRef],
  data () {
    return {
      data: {}
    }
  },
  computed: {
    currentId: function () {
      return this.data.id ?? ''
    }
  },
  mounted () {
    this.data = this.$store.getters.getGridSelectedTemplate
  },
  methods: {
    openActivateDialog () {
      this.findRefByName('activateDialog').openDialog()
    },
    openDeactivateDialog () {
      this.findRefByName('deactivateDialog').openDialog()
    }
  },
  template: `
    <div v-if="data">
        <a :id="'btnOpenActivateDialogActivate' + currentId" v-if="!data.active" href="javascript:void(0)" @click="openActivateDialog" class="tooltip-link btn btn-success btn-lg">Activate</a>
        <a :id="'btnOpenActivateDialogInactive' +  currentId" v-else href="javascript:void(0)" @click="openDeactivateDialog" class="tooltip-link btn btn-danger btn-lg">Deactivate</a>
    </div>`
})
export default StatusTooltip
</script>
